const menuState = {
    state: {
        collapsed: false
    },
    reducers: {
        toggle: (pre) => {
            pre.collapsed = !pre.collapsed;
        },
        expand: (pre) => {
            pre.collapsed = true;
        },
        collapse: (pre) => {
            pre.collapsed = false;
        }
    }
}

export {menuState}